(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('parseStateUrl', parseStateUrl);

    parseStateUrl.$inject = ['$uiRouter'];
    function parseStateUrl($uiRouter) {
        var $url = $uiRouter.urlService;

        return function parseStateUrl(url) {
            var parts, best, rule;

            if (url) {
                parts = parseUrl(url);
                best = $url.match(parts);
                rule = best && best.rule;
                if (rule && rule.type === "STATE")
                    return $uiRouter.stateService.target(rule.state, best.match);
            }
            return null;
        }

        function parseUrl(url) {
            var currentUrl = $url.url();
            try {
                $url.url(url);
                return $url.parts();
            } finally {
                $url.url(currentUrl);
            }
        }
    }
})();